@if (isAuthenticated) {
  <div class="wrapper">
    <app-top-menubar [(isSidenavOpen)]="this.isSidenavOpen"></app-top-menubar>
    <app-system-event-notification></app-system-event-notification>
    <app-side-menu [isSidenavOpen]="this.isSidenavOpen" class="flex-item-no-padding"></app-side-menu>
  </div>
}

@if (!isAuthenticated) {
  <div class="redirect">
    <div class="block">
      <div class="flex-container-center">
        <mat-spinner></mat-spinner>
      </div>
      <div class="spacer-large">
      </div>
      <span>{{ 'common.labels.redirectingToLogin' | transloco }}</span>
    </div>
  </div>
}